import SockJS from "sockjs-client";
import Stomp from "webstomp-client";

let stompClient = null;
let store = {};

function closeEventCallback() {
  stompClient.disconnect();
}

// Відключаємось від сокету коллбек
function errorCallback() {}

export const connectTypaySocket = async (
  handleTPayMessage,
  handleSocketError,
  storeData
) => {
  store = {
    tpayId: storeData.tableInfo.tableUuid,
    companyId: storeData.companyId,
  };
  const socket = new SockJS("https://ws.tpay.skyservice.online/tPay");
  // const socket = new SockJS('http://46.219.50.186:8181/tPay');
  stompClient = Stomp.over(socket);
  const headers = {
    qrToken: store.tpayId,
  };
  const messageSend = {
    qrToken: `${store.tpayId}`,
    action: "getOrders",
  };

  try {
    stompClient.connect(
      headers,
      function () {
        stompClient.subscribe("/user/queue/errors", (err) => {
          // Перевірка на офлайн пост

          if (err.body == "1001") {
            handleSocketError(true, err.body);
          } else {
            stompClient.disconnect();
          }
        });
        stompClient.subscribe("/user/queue/receiveSkyMessage", (...arg) => {
          try {
            handleSocketError(false);
            handleTPayMessage(...arg);
          } catch (error) {
            console.log(error);
          }
        });
        stompClient.ws.onclose = closeEventCallback;

        sendSocketTypayGuest(messageSend);
      },
      errorCallback
    );
  } catch (error) {
    console.log(error);
  }
};

export const sendSocketTypayGuest = (data) => {
  const companyId = store.companyId;

  window.socketType = data.action; //! current type socket
  stompClient.send("user/queue/terminal/" + companyId, JSON.stringify(data));
};
